import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { FLAG_GETTING_REGIONS,CLEAR_REGIONS,GET_REGIONS } from '../types';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { REGION_ENDPOINT } from '../../config/endpoints';
import { isErrorResponse } from '../../utils/error-handlers';

const flagGettingRegions = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_REGIONS,
    payload: flag,
  });

const getRegions = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingRegions(true));
    const query = tableFilters;
    const url = `${REGION_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const regions = await response.json();
    dispatch({
      type: GET_REGIONS,
      payload: regions,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingRegions(false));
  }
};

const clearRegions = () => (dispatch) =>
  dispatch({
    type: CLEAR_REGIONS,
  });

export {flagGettingRegions,clearRegions,getRegions};